/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { Txn } from '@src/app/model/txn';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { uuid } from '@src/app/model/abstract-object';
@Injectable({
    providedIn: 'root'
})
export class BankOutService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);

    protected get baseUrl(): string {
        return this.getAjaxPath(Txn.TYPE.BANK_OUT.code);
    }
    protected cache: Txn[];
    protected typeString = Txn.TYPE.BANK_OUT.name;

    getOutstanding(id: uuid): Observable<Txn[]> {
        return this.http.get<Txn[]>(this.baseUrl + '/' + id + '/outstanding')
            .pipe(
                catchError(this.handleOneError<Txn[]>('getOutstanding' + this.typeString, []))
            );
    }

}
